import { ArrowBack, Close } from "@mui/icons-material";
import { Box, Button, IconButton, Modal, Paper } from "@mui/material";
import React, { memo, useEffect, useMemo, useState } from "react";

type StyledModalProps = {
  open: boolean;
  backgroundColor?: string;
  onClose?: () => void;
  extraButton?: React.ReactNode;
  children: React.ReactNode;
  onShow: () => void;
  onBack?: () => void;
  tabVersion?: boolean;
  scrollable?: boolean;
  topSpace?: number | "auto";
};

function StyledModal({
  open,
  onClose,
  onBack,
  backgroundColor = "white",
  children,
  onShow,
  extraButton,
  scrollable = true,
  tabVersion = false,
  topSpace,
}: StyledModalProps) {
  // delay onShow a bit and clean up if modal closes quickly
  useEffect(() => {
    if (!open) return;
    const id = setTimeout(onShow, 500);
    return () => clearTimeout(id);
  }, [open, onShow]);

  if (!open) return null;

  return (
    <Modal
      sx={{ p: "3em", display: "flex", overflow: "hidden", alignItems: "center", justifyContent: "center" }}
      open={open}
      onClose={onClose ?? (() => {})}
    >
      <Box sx={{ maxHeight: "100%", minWidth: "50vw", maxWidth: "1000px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            mb: "10px",
            justifyContent: "space-between",
          }}
        >
          {!!extraButton ? (
            extraButton
          ) : !!onBack ? (
            <Paper sx={{}}>
              <IconButton onClick={onBack}>
                <ArrowBack />
              </IconButton>
            </Paper>
          ) : (
            <Box />
          )}
          {!!onClose ? (
            <Paper sx={{ borderRadius: "20px", overflow: "hidden" }}>
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            </Paper>
          ) : (
            <Box />
          )}
        </Box>
        <Paper
          elevation={3}
          sx={{
            p: 2,
            position: "relative",
            overflow: "scroll",
            backgroundColor,
            flex: 1,
          }}
        >
          {children}
        </Paper>
      </Box>
    </Modal>
  );
}

export default memo(StyledModal);
